import { useState, useEffect, useRef, Fragment, memo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./FriendPage.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import { SwipeRight } from "@mui/icons-material";
import apiManager from '../../ApiManager';
import { GameContext } from "../../GameContext";
const FriendPage = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [badges, set_badges] = useState([]);
    const [ownerFriends, set_ownerFriends] = useState(0);
    const [currentVo, set_currentVo] = useState(null);
    const { friends, set_friends } = useContext(GameContext);
    useEffect(() => {
        setInProp(true);
        apiManager.fetchGet(`user/${arg.friendVo.user_friends_detail.user_id}/badges`, {}, 0).then(badges => {
            loadData(badges ?? []);
        });
        apiManager.fetchGet(`user/${arg.friendVo.user_friends_detail.user_id}/friends`, {}, 0).then(res => {
            set_ownerFriends(res.length);
        });
        document.title = "好友";
    }, [])
    const loadData = async (badges) => {
        try {
            const path = `./badge.json`;
            const response = await fetch(path);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            const _badage = [];
            badges.forEach(_v => {
                const obj = jsonData.find(v => v.id === _v.badges_code);
                obj.times = _v.badges_count;
                _badage.push(obj);
            })
            set_badges(_badage);
        } catch (error) {
            console.log(error)
        }
    };

    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.SwipePageEnterActive,
                enterDone: style.SwipePageEnterDone,
                exitActive: style.SwipePageExit,
                exitDone: style.SwipePageExitActive
            }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "FriendPage"))
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`} >
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={e => { setInProp(false) }} />
                        </div>
                        <div className={styleUi.view}>
                            <YStyled.Label style={{ width: "100%", justifyContent: "space-between" }}>
                                <YStyled.Col>
                                    <YStyled.Row>
                                        <FriendInfo user={arg.friendVo.user_friends_detail} type={5} />
                                        <YStyled.Row style={{ width: "50%" }}>
                                            <YStyled.Col align="center" gap=".4rem">
                                                <YStyled.Row align="center" style={{ width: "1.5rem", height: "1.5rem" }}>
                                                    <YStyled.Span size={13}>{ownerFriends}</YStyled.Span>
                                                </YStyled.Row>
                                                <YStyled.Span size={13}>朋友</YStyled.Span>
                                            </YStyled.Col>
                                            <YStyled.Col align="center" gap=".4rem">
                                                <img src="./assets/ui/bars.svg" style={{ width: "1.5rem", height: "1.5rem" }} />
                                                <YStyled.Span size={13}>統計</YStyled.Span>
                                            </YStyled.Col>
                                            <YStyled.Col align="center" gap=".4rem">
                                                <img src="./assets/ui/hand.svg" style={{ width: "1.5rem", height: "1.5rem" }} />
                                                <YStyled.Span size={13}>揪我</YStyled.Span>
                                            </YStyled.Col>
                                        </YStyled.Row>
                                    </YStyled.Row>
                                    {arg.friendVo.user_friends_status === 0 &&
                                        <YStyled.BTN3 normalBg="#654721" normalColor="white" style={{ marginTop: "1.5rem", width: "100%", borderRadius: "6px", padding: ".8rem", borderWidth: "0px" }} onClick={e => {
                                            apiManager.fetchPost(`user/friends`, {
                                                "user_id": arg.friendVo.user_friends_detail.user_id
                                            }, 0).then(res => {
                                                console.log("res", res)
                                                set_friends(prevFriends => [...prevFriends, res]);
                                                arg.set_friends(prevFriends=>{
                                                    const _prevFriends=[...prevFriends];
                                                    const findFriend=_prevFriends.find(v=>v.user_friends_detail.user_id===arg.friendVo.user_friends_detail.user_id);
                                                    if(findFriend)
                                                    {
                                                        findFriend.user_friends_status=res.user_friends_status;
                                                    }
                                                    return _prevFriends;
                                                })
                                            })
                                        }}>
                                            <YStyled.Span size={17} >加好友</YStyled.Span>
                                        </YStyled.BTN3>
                                    }
                                    {arg.friendVo.user_friends_status === 1 &&
                                        <YStyled.BTN3 normalBg="#C2A532" normalColor="white" style={{ marginTop: "1.5rem", width: "100%", borderRadius: "6px", padding: ".8rem", borderWidth: "0px" }} onClick={e => {
                                            apiManager.fetchDelete(`user/friends/${arg.friendVo.user_friends_detail.user_id}`,{},0).then(res=>{
                                                console.log("res",res);
                                            })
                                            /* addModalType({
                                                cls: "BottomAlert", arg: {
                                                    type: "cancelFriendInvite",
                                                    cb: cmd => {
                                                        if(cmd==="swipe"){

                                                        }
                                                    }
                                                }
                                            }) */
                                        }}>
                                            <YStyled.Span size={17} >己傳送</YStyled.Span>
                                        </YStyled.BTN3>
                                    }
                                    {arg.friendVo.user_friends_status === 2 &&
                                        <YStyled.BTN3 normalBg="#C2A532" normalColor="white" style={{ marginTop: "1.5rem", width: "100%", borderRadius: "6px", padding: ".8rem", borderWidth: "0px" }} onClick={e => {
                                           /*  apiManager.fetchDelete(`user/friends/${arg.friendVo.user_friends_detail.user_id}`,{},0).then(res=>{
                                                console.log("res",res);
                                            }).catch(err=>{
                                                alert(err)
                                            }) */
                                        }}>
                                            <YStyled.Span size={17} >你的好友</YStyled.Span>
                                        </YStyled.BTN3>
                                    }
                                </YStyled.Col>
                            </YStyled.Label>
                            <YStyled.Row gap=".6rem" style={{ marginTop: "1rem" }}>
                                <YStyled.Label style={{ width: "50%", aspectRatio: "5/2" }} onClick={e => {
                                    addModalType({
                                        cls: "Tab1Template", arg: {
                                            friendVo: arg.friendVo.user_friends_detail
                                        }
                                    })
                                }}>
                                    <YStyled.Span size={15} fontWeight={400}>基地營</YStyled.Span>
                                    <img src="./assets/ui/rightArrow_2.svg" />
                                </YStyled.Label>
                                <YStyled.Label style={{ width: "50%", aspectRatio: "5/2" }} onClick={e => {
                                    addModalType({
                                        cls: "Tab2Template", arg: {
                                            friendVo: arg.friendVo.user_friends_detail
                                        }
                                    })
                                }}>
                                    <YStyled.Span size={15} fontWeight={400}>星空地圖成就</YStyled.Span>
                                    <img src="./assets/ui/rightArrow_2.svg" />
                                </YStyled.Label>
                            </YStyled.Row>
                            <YStyled.Span size={15} color="#71532D" style={{ alignSelf: "flex-start", margin: "1rem 0" }}>新手勳章</YStyled.Span>
                            <div className={styleUi.achievements}>
                                {
                                    badges.filter(v => v.type === 1).map((v, k) => {
                                        return <div key={k} className={styleUi.item} onClick={e => { set_currentVo(v) }}>
                                            <img src={`./assets/rewild/${v.id}.png`} />
                                        </div>
                                    })
                                }
                            </div>
                            <YStyled.Span size={15} color="#71532D" style={{ alignSelf: "flex-start", margin: "1rem 0" }}>歷程勳章</YStyled.Span>
                            <div className={styleUi.achievements}>
                                {
                                    badges.filter(v => v.type === 2).map((v, k) => {
                                        return <div key={k} className={styleUi.item} onClick={e => { set_currentVo(v) }}>
                                            <img src={`./assets/rewild/${v.id}.png`} />
                                        </div>
                                    })
                                }
                            </div>
                            <YStyled.Span size={15} color="#71532D" style={{ alignSelf: "flex-start", margin: "1rem 0" }}>月勳章</YStyled.Span>
                            <div className={styleUi.achievements}>
                                {
                                    badges.filter(v => v.type === 3).map((v, k) => {
                                        return <div key={k} className={styleUi.item} onClick={e => { set_currentVo(v) }}>
                                            <img src={`./assets/rewild/${v.id}.png`} />
                                        </div>
                                    })
                                }
                            </div>
                            {currentVo &&
                                <div className={styleUi.achievementDetail}>
                                    <img src={`./assets/rewild/${currentVo.id}.png`} />
                                    <div className={styleUi.infoBox}>

                                        {currentVo.type === 1 &&
                                            <>
                                                <YStyled.Span size={17}>{currentVo.name}</YStyled.Span>
                                                <YStyled.Span size={15} fontWeight={400}>{currentVo.info}</YStyled.Span>
                                            </>
                                        }
                                        {currentVo.type === 2 &&
                                            <>
                                                <YStyled.Span size={17}>{currentVo.info}</YStyled.Span>
                                                <YStyled.Span size={28} fontWeight={400}>{currentVo.times}</YStyled.Span>
                                            </>
                                        }
                                        {currentVo.type === 3 &&
                                            <>
                                                <YStyled.Span size={17}>{currentVo.name}</YStyled.Span>
                                                <YStyled.Span size={15} fontWeight={400}>{currentVo.info}</YStyled.Span>
                                                <YStyled.Span size={15} fontWeight={300}>x {currentVo.times}</YStyled.Span>
                                            </>
                                        }
                                    </div>
                                    <img src="./assets/ui/x.svg" className={styleUi.closeBtn} onClick={e => {
                                        set_currentVo(null)
                                    }} />
                                </div>
                            }
                        </div>

                    </div>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(FriendPage);